// extracted by css-extract-rspack-plugin
export default {"MetabotLogo":"MetabotLogo-module__MetabotLogo___A7UMY"};